import { render, staticRenderFns } from "./_projects.vue?vue&type=template&id=0bc20f74&"
import script from "./_projects.vue?vue&type=script&lang=ts&"
export * from "./_projects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc20f74')) {
      api.createRecord('0bc20f74', component.options)
    } else {
      api.reload('0bc20f74', component.options)
    }
    module.hot.accept("./_projects.vue?vue&type=template&id=0bc20f74&", function () {
      api.rerender('0bc20f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/mypages/nemesys/_projects.vue"
export default component.exports